import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/** `YYYY-MM-DDTHH:mm` in local time, as `datetime-local` takes it. */
function toLocalInput(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
}

/**
 * A date and time in the browser's time zone, handed on as an ISO instant
 * (016 Assumptions "Scheduled times"). Whether it's in the future is the
 * server's to say.
 */
export default function ScheduleField({
  id,
  label = 'Publish on',
  value,
  onChange,
}: {
  id: string;
  label?: string;
  value: string | null;
  onChange: (iso: string | null) => void;
}) {
  const [text, setText] = useState(toLocalInput(value));
  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="datetime-local"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          const at = new Date(e.target.value);
          onChange(e.target.value && !isNaN(at.getTime()) ? at.toISOString() : null);
        }}
        className="mt-1"
      />
    </div>
  );
}
